import angular from 'angular'

import { WorkOrderDashboardModule } from './dashboard/work-order-dashboard.module';
import { WorkOrderDetailModule } from './detail/work-order-detail.module';
import { WorkOrderEditModule } from './edit/work-order-edit.module';
import { WorkOrderRoutingModule } from './work-order-routing.module';

export const WorkOrderModule = angular
    .module("apex.mainApp.workOrder", [
        WorkOrderDashboardModule,
        WorkOrderDetailModule,
        WorkOrderEditModule,
        WorkOrderRoutingModule
    ])
    .name
